const styles = {
  headerRight: {
    marginLeft: 'auto',
    display: 'flex',
    justifyContent: 'space-between',
    gap: '10px',
  },
  error: {
    color: 'red',
  },
};

export default styles;
